import React from "react";
import { Link } from "react-router-dom";
import publications from "../data/publicationsData";

const Publications = () => {
  return (
    <section className="relative bg-brandBlue text-white font-outfit px-6 py-16 xs:py-8 xxs:py-8 min-h-screen overflow-hidden">
      {/* Decorative blurred gradients */}
      <div className="absolute top-[-100px] left-[-100px] w-[300px] h-[300px] bg-softGreen/30 blur-3xl rounded-full z-0" />
      <div className="absolute bottom-[-100px] right-[-100px] w-[300px] h-[300px] bg-brandGreen/20 blur-3xl rounded-full z-0" />

      <div className="relative z-10 max-w-5xl mx-auto">
        <h3 className=" text-2xl leading-[1.3125rem] mb-[3rem] uppercase tracking-[0.2em] font-normal text-center text-white xxs:text-lg xs:text-lg xxs:mb-[1.5rem] xs:mb-[1.5rem]">
          Publications & Reports
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {publications.map((pub) => (
            <div
              key={pub.id}
              className="bg-[#0F1C4D] rounded-2xl hover:shadow-lg transition-shadow overflow-hidden flex flex-col"
            >
              {pub.image && (
                <div className="relative h-44 overflow-hidden">
                  <img
                    src={pub.image}
                    alt=""
                    className="w-full h-full object-cover transition-transform duration-500 hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#0F1C4D] via-transparent to-transparent" />
                </div>
              )}
              <div className="p-6 flex flex-col flex-1">
                <h3 className="text-[1.3125rem] xs:text-base xxs:text-base font-semibold mb-2">
                  {pub.title}
                </h3>
                <p className="text-sm text-[#04DDAD] mb-1">{pub.category}</p>
                <p className="text-base text-gray-300 mb-4 flex-1">
                  {pub.description}
                </p>
                <div className="flex gap-4 flex-wrap">
                  {pub.file ? (
                    <>
                      <a
                        href={pub.file}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-block bg-gradient-to-r from-[#04DDAD] to-[#34ACAC] text-white text-sm font-semibold px-4 py-2 rounded-xl hover:opacity-90 transition"
                      >
                        View File
                      </a>
                      <a
                        href={pub.file}
                        download
                        className="inline-block bg-white text-[#0F1C4D] text-sm font-semibold px-4 py-2 rounded-xl hover:bg-gray-200 transition"
                      >
                        Download
                      </a>
                    </>
                  ) : (
                    <Link
                      to={`/publications/${pub.id}`}
                      className="inline-block bg-gradient-to-r from-[#04DDAD] to-[#34ACAC] text-white text-sm font-semibold px-4 py-2 rounded-xl hover:opacity-90 transition"
                    >
                      Read more →
                    </Link>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Publications;
